<script module lang="ts">
  import type { GraphViewFrameContext } from "../../_shared/_logic/graph-contract"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import { getTabs } from "./metadata"
  export { getTabs } from "./metadata"
</script>

<script lang="ts">
  import ProvisioningTab from "./tabs/Provisioning"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: GraphViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by(() => ({
    graph: viewFrameContext.graph,
    draft: viewFrameContext.draft,
    loading: viewFrameContext.loading,
    error: viewFrameContext.error,
    hasChanges: viewFrameContext.hasChanges,
    saving: viewFrameContext.saving,
    synchronizing: viewFrameContext.synchronizing,
    onSave: viewFrameContext.onSave,
    onReset: viewFrameContext.onReset,
    onSynchronize: viewFrameContext.onSynchronize,
  }))
</script>

{#if activeTab === "provisioning"}
  {#key viewFrameContext.draft}
    <ProvisioningTab {viewFrameContext} {pageContext} />
  {/key}
{/if}
